import { Paper, Box, IconButton, Tooltip } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import DownloadIcon from "@mui/icons-material/Download";
import { LeadsManagementData } from "../hooks/useLeadsManagementData";
import { BRAND_COLOR } from "../constants";
import { exportLeadsToCSV } from "../leadsCsvHelpers";
import LeadsFilterItems from "./LeadsFilterItems";

interface LeadsFilterCardProps {
  data: LeadsManagementData;
}

export default function LeadsFilterCard({ data }: LeadsFilterCardProps) {
  const { leadsForStatus, refetch, isLoading } = data;

  return (
    <Paper
      variant="outlined"
      sx={{
        mt: 2,
        p: "14px 18px",
        borderRadius: 2,
        display: "flex",
        flexWrap: "wrap",
        gap: 1.5,
        alignItems: "flex-end",
      }}
    >
      <LeadsFilterItems data={data} />
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, pb: 0.5, ml: "auto" }}>
        <Tooltip title="Refresh">
          <IconButton onClick={refetch} disabled={isLoading} data-tracker="926" sx={{ color: BRAND_COLOR }}>
            <RefreshIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Export">
          <IconButton
            onClick={() => exportLeadsToCSV({ leads: leadsForStatus })}
            disabled={isLoading}
            data-tracker="927"
            sx={{ color: BRAND_COLOR }}
          >
            <DownloadIcon />
          </IconButton>
        </Tooltip>
      </Box>
    </Paper>
  );
}
